import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Checkbox, Modal, Upload, Table, Tree } from "antd";

import Http from "../../commons/utils/Http";
import Message from "../../commons/utils/message";

import { useSelector, useDispatch } from "react-redux";
import { setModuleData, unsetModuleData } from "../../store/actions/moduleActions";

import Content from "../../commons/components/content";
import Pagination from "../../commons/components/pagination";
import Input from "../../commons/components/input";
import SearchInput from "../../commons/components/searchInput";
import ButtonIcon from "../../commons/components/buttonIcon";
import Loading from "../../commons/components/loading";
import Permissions from '../../commons/utils/permissions'

import ServiceModule from '../../services/modules'
import ServiceFunctions from '../../services/functions'

export default () => {

    const moduleState = useSelector(state => state.module);
    const { screens } = useSelector(state => state.userLogin);
    const [permissions] = useState([]);
    const dispatch = useDispatch();

    const [loadingTable, setLoadingTable] = useState(true);
    const [loadingFunctions, setLoadingFunctions] = useState(true);
    const [loadingModuleFunctions, setLoadingModuleFunctions] = useState(true);

    const [actualPage, setActualPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");

    let [selectedModule, setSelectedModule] = useState({})

    let [showModuleModal, setShowModuleModal] = useState(false);
    let [showDeleteModal, setShowDeleteModal] = useState(false);
    let [showFunctionsModal, setShowFunctionsModal] = useState(false);

    const [nomeError, setNomeError] = useState(false);
    const [descricaoError, setDescricaoError] = useState(false);
    const [screenNameError, setScreenNameError] = useState(false);

    const [treeData, setTreeData] = useState([]);
    const { TreeNode } = Tree;
    const [checkedKeys, setCheckedKeys] = useState([])

    const tableColumns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Ativo',
            dataIndex: 'active',
            key: 'active',
        },
        {
            title: 'Ação',
            key: 'action',
            render: (text, module) => (
                <div style={{ display: 'flex' }}>
                    {(permissions.find(_function => _function.function_id === Permissions.ASSOCIAR_FUNCAO)) ?
                        <ButtonIcon className="button-edit" text="Associar Função" type="menu-unfold" callback={() => handleFunctionsModal(module)} />
                        : null
                    }

                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_MODULO)) ?
                        <ButtonIcon className="button-edit" text="Editar Módulo" type="edit" callback={() => handleEditModule(module)} />
                        : null
                    }

                    {(permissions.find(_function => _function.function_id === Permissions.EXCLUIR_MODULO)) ?
                        <ButtonIcon className="button-red" text="Excluir Módulo" type="delete" callback={() => handleDeleteModule(module)} />
                        : null
                    }
                </div>
            ),
        },
    ];

    const [tableData, setTableData] = useState([])

    useEffect(() => {
        screens.map(screen => {
            if (screen.url === "/modules") {
                screen.functions.map(func => {
                    permissions.push(func)
                })
            }
        });
    }, []);

    useEffect(() => {
        if (search === "") {
            getModules();
        }
    }, [search]);

    useEffect(() => {
        if (showFunctionsModal && moduleState.id) {
            getModuleFunctions();
        }
    }, [showFunctionsModal]);

    function onCheckTree(checkedKeys) {
        setCheckedKeys(checkedKeys);
    };

    function getModulesOrSearch(page) {
        if (search === "") {
            getModules(page)
        } else {
            searchModule(search, page)
        }
    }

    async function getModules(page = 1) {
        setLoadingTable(true);
        let response = await ServiceModule.getAll(page)
        if (response) {
            formatTable(response.data);
            setActualPage(page);
            setTotalPages(response.data.pagination);
            setLoadingTable(false);
        }
        setShowModuleModal(false)
    }

    async function getModule(id) {
        setLoadingTable(true);
        let response = await ServiceModule.getId(id)
        if (response) {
            setSelectedModule(response.data.data[0]);
            setLoadingTable(false);
        }
    }

    async function searchModule(search) {
        setLoadingTable(true);
        let response = await ServiceModule.search(search)
        if (response) {
            formatTable(response.data.data);
            setActualPage(search);
            setTotalPages(response.data.pagination);
            setLoadingTable(false);
        }
    }

    async function getFunctions() {
        setLoadingFunctions(true);
        let response = await ServiceFunctions.getFunctions();
        if (response) {
            let array = [];
            const data = response.data.data;
            data.forEach((item) => {
                item.index = item.id
                array.push(item)
            })
            setTreeData(array)
            setLoadingFunctions(false);
        }
    }

    async function getModuleFunctions() {
        setLoadingModuleFunctions(true);
        Http.get(`/functions/get-functions-by-module?id=${moduleState.id}`, Http.headers)
            .then(response => {
                if (!response.data.response.error) {
                    let array = [];
                    const data = response.data.data;
                    data.forEach((item) => {
                        array.push(item.function_id)
                    })
                    setCheckedKeys(array);
                    setLoadingModuleFunctions(false);
                }
            }).catch(err => {
                setCheckedKeys([]);
                setLoadingModuleFunctions(false);
            })
    }

    function formatTable(data) {
        let array = [];
        data.data.forEach((module) => {
            module.key = module.id;
            module.active = module.active === true ? "Sim" : "Não";
            array.push(module);
        })
        setTableData(array);
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchModule(search);
        }
    }

    function validateForm() {
        let valid = true;

        if (!selectedModule.name) {
            setNomeError(true);
            Message.showError("Informe o nome");
            valid = false;
        }

        if (!selectedModule.description) {
            setDescricaoError(true);
            Message.showError("Informe a descrição");
            valid = false;
        }

        if (selectedModule.screen && !selectedModule.screen_name) {
            setScreenNameError(true);
            Message.showError("Informe o nome da tela");
            valid = false;
        }

        return valid;
    }

    function handleSaveModalModule() {
        setLoadingTable(true);
        if (validateForm()) {
            if (selectedModule.id) {
                update(selectedModule)
            } else {
                insert(selectedModule)
            }
        }
        setLoadingTable(false);
    }

    function handleSaveModalFunctions() {
        setLoadingTable(true);
        if (checkedKeys.length === 0) {
            Message.showError('Selecione uma função')
        } else {
            const body = {};
            const bodyFunctions = [];

            checkedKeys.sort().forEach((item) => {
                bodyFunctions.push({
                    "module_id": moduleState.id,
                    "function_id": item
                })
            })

            body.module_id = moduleState.id
            body.functions = bodyFunctions;

            saveModuleFunctions(body)
            setShowFunctionsModal(false);
        }
        setLoadingTable(false);
    }

    function handleConfirmDeleteModule() {
        setLoadingTable(true);
        remove(selectedModule);
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    function handleCancelModalModule() {
        setSelectedModule({});
        setShowModuleModal(false);

        setNomeError(false);
        setDescricaoError(false);
    }

    function handleCalcelDeleteModule() {
        setSelectedModule({});
        setShowDeleteModal(false);
    }

    function handleCancelModalFunctions() {
        setSelectedModule({});
        setShowFunctionsModal(false);
    }

    function handleEditModule(module) {
        setLoadingTable(true);
        getModule(module.id);
        setShowModuleModal(true);
        setLoadingTable(false);
    }

    function handleDeleteModule(module) {
        setLoadingTable(true);
        getModule(module.id);
        setShowDeleteModal(true);
        setLoadingTable(false);
    }

    function handleFunctionsModal(module) {
        getFunctions();
        dispatch(setModuleData(module));
        setShowFunctionsModal(true);
    }

    function handleKeyPress(e) {
        if (e.key === "Enter") {
            handleSaveModalModule();
        }
    }

    function returnConfirmAction() {
        if (search !== "") {
            searchModule(search);
        } else {
            getModules(actualPage)
        }
    }

    async function insert(data) {
        let response = await ServiceModule.insert(data)
        returnConfirmAction()
    }

    async function saveModuleFunctions(data) {
        let response = await ServiceModule.saveModuleFunctions(data)
        returnConfirmAction()
    }

    async function update(data) {
        let response = await ServiceModule.update(data)
        returnConfirmAction()
    }

    async function remove(data) {
        let response = await ServiceModule.delete(data.id)
        returnConfirmAction()
    }

    const newModuleModal = () => (
        <Modal
            title="Cadastro de Módulos" visible={showModuleModal} onCancel={handleCancelModalModule}
            footer={[
                <button key="cancel" onClick={handleCancelModalModule} className="btn btn-light">Cancelar</button>,
                <button key="confirm" onClick={handleSaveModalModule} className="btn btn-primary">Salvar</button>
            ]}>

            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input
                            name="name" label="Nome"
                            value={selectedModule.name ? selectedModule.name : ''}
                            hasError={nomeError}
                            onChange={(e) => { setSelectedModule({ ...selectedModule, name: e.target.value }); setNomeError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            name="description" label="Descrição"
                            value={selectedModule.description ? selectedModule.description : ''}
                            hasError={descricaoError}
                            onChange={(e) => { setSelectedModule({ ...selectedModule, description: e.target.value }); setDescricaoError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox
                            inputId="cbScreen"
                            onChange={(e) => {
                                setSelectedModule({ ...selectedModule, screen: e.target.checked });
                            }}
                            checked={selectedModule.screen}
                        />
                        <label htmlFor="cbScreen" className="p-checkbox-label" style={{ marginLeft: '5px' }}>Screen</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            readOnly={!selectedModule.screen}
                            name="url" label="Url"
                            value={selectedModule.url ? selectedModule.url : ''}
                            onChange={(e) => { setSelectedModule({ ...selectedModule, url: e.target.value }) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <Input
                            readOnly={!selectedModule.screen}
                            name="scrren_name" label="Nome Tela"
                            value={selectedModule.screen_name ? selectedModule.screen_name : ''}
                            hasError={screenNameError}
                            onChange={(e) => { setSelectedModule({ ...selectedModule, screen_name: e.target.value }); setScreenNameError(false) }}
                            onKeyPress={(e) => handleKeyPress(e)} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox
                            inputId="cbAtivo"
                            onChange={(e) => { setSelectedModule({ ...selectedModule, active: e.target.checked }) }}
                            checked={selectedModule.active}
                        />
                        <label htmlFor="cbAtivo" className="p-checkbox-label" style={{ marginLeft: '5px' }}>Ativo</label>
                    </div>
                </div>
            </div>
        </Modal>
    );

    const deleteModuleModal = () => (
        <Modal visible={showDeleteModal} title="Excluir módulo"
            onCancel={handleCalcelDeleteModule} cancelText="Cancelar" onOk={handleConfirmDeleteModule} okText="Excluir"
            okType="danger">

            <p>Tem certeza que deseja excluir o módulo <strong>{selectedModule.name}</strong> ?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    const functionsModal = () => {

        function renderFunctions() {
            if (loadingFunctions || loadingModuleFunctions) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                function renderTreeNodes(data) {
                    return data.map(item => {
                        return <TreeNode title={item.name} key={item.index} {...item} />;
                    });
                }

                function renderFunctions() {
                    return (
                        <>
                            <Tree
                                checkable
                                autoExpandParent={true}
                                onCheck={onCheckTree}
                                checkedKeys={checkedKeys}
                            >
                                {renderTreeNodes(treeData)}
                            </Tree>
                        </>
                    )
                }

                return (
                    <>
                        <div className="tree-data-container-functions">
                            {renderFunctions()}
                        </div>
                    </>
                );
            }
        }

        return (
            <Modal visible={showFunctionsModal} title={'Associação de Funções'}
                onCancel={handleCancelModalFunctions} cancelText="Cancelar"
                onOk={handleSaveModalFunctions} okText="Salvar">

                {renderFunctions()}
            </Modal>
        )
    };

    const renderSearchModule = () => (
        <div style={{ marginBottom: 10 }}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")} />
        </div>
    );

    const renderLoading = () => {
        if (loadingTable) {
            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Loading width={50} height={50} />
                </div>
            )
        }
    };

    const renderAddModuleButton = () => {
        if (permissions.find(_function => _function.function_id === Permissions.CADASTRAR_MODULO)) {
            function handleOpenModal() {
                setSelectedModule({ active: true });
                setShowModuleModal(true)
            }

            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <ButtonIcon className="button-green" text="Adicionar Módulo" type="plus" label="Adicionar" callback={handleOpenModal} />
                </div>
            )
        }
    };

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table pagination={false} columns={tableColumns} dataSource={tableData} />
                </div>
            </Col>
        </Fragment>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={8}>
                {renderSearchModule()}
            </Col>
            <Col span={10}>
                {renderLoading()}
            </Col>
            <Col span={6}>
                {renderAddModuleButton()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Módulos"]} minHeight={360}>
                {newModuleModal()}
                {deleteModuleModal()}
                {functionsModal()}
                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>
                <Row>
                    {renderTable()}
                </Row>
                <Row type="flex" align="middle">
                    <Col span={12}>
                        <Pagination totalPages={totalPages} actualPage={actualPage} callBack={(page) => getModulesOrSearch(page)} />
                    </Col>
                </Row>
            </Content>
        </>
    )
}